import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  const { t } = useTranslation();

  const socialLinks = [
    {
      icon: faFacebookF,
      // link: "https://www.facebook.com/share/1Hqb5P4ugV/?mibextid=wwXIfr",
    },
  ];

  const quickLinks = [
    { title: t("our_services"), link: "#services" },
    { title: t("products-menu"), link: "#products" },
    { title: t("about_us_link"), link: "#about" },
    { title: t("contact_us_link"), link: "#contact" },
  ];

  return (
    <div
      className="container-fluid bg-dark footer mt-5 py-5 wow fadeIn"
      data-wow-delay="0.1s"
    >
      <div className="container py-5">
        <div className="row g-5">

          <div className="col-lg-4 col-md-6 justify-items-start">
            <h4 className="fw-bold mb-3 text-accent">{t("our_office")}</h4>
            <p className="mb-2">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="me-fa text-accent" />
              {t("location_text")}
            </p>

            <p className="mb-2">
              <FontAwesomeIcon icon={faWhatsapp} className="me-fa text-accent" />
              218914907007+
            </p>

            <p className="mb-2">
              <FontAwesomeIcon icon={faEnvelope} className="me-fa text-accent" />
              info@mawasemaltejarea.ly
            </p>
          </div>

          <div className="col-lg-4 col-md-6 justify-items-start">
            <h4 className="fw-bold mb-3 text-accent">{t("quick_links")}</h4>
            {quickLinks.map((link, index) => (
              <a key={index} className="btn btn-link" href={link.link}>
                {link.title}
              </a>
            ))}
          </div>

          <div className="col-lg-4 col-md-6 justify-items-start">
            <h4 className="fw-bold mb-3 text-accent">{t("company-name")}</h4>
            <p style={{ textAlign: "start" }}>{t("footer-description")}</p>
          </div>

          <div className="d-flex pt-3" style={{ paddingBottom: "10px" }}>
            {socialLinks.map((social, index) => (
              <a
                key={index}
                className="btn btn-square btn-accent rounded-circle me-2"
                href={social.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={social.icon} />
              </a>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
};

export default Footer;
